/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-mixed-operators, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars, default-case, jsdoc/require-param*/
import $protobuf from "protobufjs/minimal.js";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
const $Object = $util.global.Object, $undefined = $util.global.undefined, $Error = $util.global.Error, $RangeError = $util.global.RangeError, $Array = $util.global.Array, $TypeError = $util.global.TypeError, $String = $util.global.String, $Number = $util.global.Number, $parseInt = $util.global.parseInt, $BigInt = $util.global.BigInt, $isFinite = $util.global.isFinite;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const pb = $root.pb = (() => {

    /**
     * Namespace pb.
     * @exports pb
     * @namespace
     */
    const pb = {};

    pb.ActionResponse = (function() {

        /**
         * Properties of an ActionResponse.
         * @typedef {Object} pb.ActionResponse.$Properties
         * @property {Array.<pb.ActionItem.$Properties>|null} [items] ActionResponse items
         * @property {Object.<string,string>|null} [statistics] ActionResponse statistics
         * @property {Array.<pb.Live.$Properties>|null} [lives] ActionResponse lives
         * @property {number|Long|null} [total] ActionResponse total
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an ActionResponse.
         * @memberof pb
         * @interface IActionResponse
         * @augments pb.ActionResponse.$Properties
         * @deprecated Use pb.ActionResponse.$Properties instead.
         */

        /**
         * Shape of an ActionResponse.
         * @typedef {pb.ActionResponse.$Properties} pb.ActionResponse.$Shape
         */

        /**
         * Constructs a new ActionResponse.
         * @memberof pb
         * @classdesc Represents an ActionResponse.
         * @constructor
         * @param {pb.ActionResponse.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const ActionResponse = function (properties) {
            this.items = [];
            this.statistics = {};
            this.lives = [];
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * ActionResponse items.
         * @member {Array.<pb.ActionItem.$Properties>} items
         * @memberof pb.ActionResponse
         * @instance
         */
        ActionResponse.prototype.items = $util.emptyArray;

        /**
         * ActionResponse statistics.
         * @member {Object.<string,string>} statistics
         * @memberof pb.ActionResponse
         * @instance
         */
        ActionResponse.prototype.statistics = $util.emptyObject;

        /**
         * ActionResponse lives.
         * @member {Array.<pb.Live.$Properties>} lives
         * @memberof pb.ActionResponse
         * @instance
         */
        ActionResponse.prototype.lives = $util.emptyArray;

        /**
         * ActionResponse total.
         * @member {number|Long} total
         * @memberof pb.ActionResponse
         * @instance
         */
        ActionResponse.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ActionResponse instance using the specified properties.
         * @function create
         * @memberof pb.ActionResponse
         * @static
         * @param {pb.ActionResponse.$Properties=} [properties] Properties to set
         * @returns {pb.ActionResponse} ActionResponse instance
         * @type {{
         *   (properties: pb.ActionResponse.$Shape): pb.ActionResponse & pb.ActionResponse.$Shape;
         *   (properties?: pb.ActionResponse.$Properties): pb.ActionResponse;
         * }}
         */
        ActionResponse.create = function(properties) {
            return new ActionResponse(properties);
        };

        /**
         * Encodes the specified ActionResponse message. Does not implicitly {@link pb.ActionResponse.verify|verify} messages.
         * @function encode
         * @memberof pb.ActionResponse
         * @static
         * @param {pb.ActionResponse.$Properties} message ActionResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActionResponse.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.pb.ActionItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.statistics != null && $Object.hasOwnProperty.call(message, "statistics"))
                for (let keys = $Object.keys(message.statistics), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.statistics[keys[i]]).ldelim();
            if (message.lives != null && message.lives.length)
                for (let i = 0; i < message.lives.length; ++i)
                    $root.pb.Live.encode(message.lives[i], writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
            if (message.total != null && $Object.hasOwnProperty.call(message, "total") && (typeof message.total === "object" ? message.total.low || message.total.high : message.total !== 0))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.total);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ActionResponse message, length delimited. Does not implicitly {@link pb.ActionResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pb.ActionResponse
         * @static
         * @param {pb.ActionResponse.$Properties} message ActionResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActionResponse.encodeDelimited = function(message, writer) {
            return this.encode(message, (writer || $Writer.create()).fork()).ldelim();
        };

        /**
         * Decodes an ActionResponse message from the specified reader or buffer.
         * @function decode
         * @memberof pb.ActionResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pb.ActionResponse & pb.ActionResponse.$Shape} ActionResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActionResponse.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, key, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.pb.ActionResponse();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.pb.ActionItem.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if (message.statistics === $util.emptyObject)
                            message.statistics = {};
                        let end2 = reader.uint32() + reader.pos;
                        if (end2 > reader.len)
                            throw $RangeError("index out of range");
                        reader.len = end2;
                        key = "";
                        value = "";
                        while (reader.pos < end2) {
                            let tag2 = reader.tag();
                            wireType = tag2 & 7;
                            switch (tag2 >>>= 3) {
                            case 1:
                                if (wireType !== 2)
                                    break;
                                key = reader.stringVerify();
                                continue;
                            case 2:
                                if (wireType !== 2)
                                    break;
                                value = reader.stringVerify();
                                continue;
                            }
                            reader.skipType(wireType, _depth, tag2);
                        }
                        if (reader.pos !== end2)
                            throw $RangeError("index out of range");
                        reader.len = end;
                        if (key === "__proto__")
                            $util.makeProp(message.statistics, key);
                        message.statistics[key] = value;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if (!(message.lives && message.lives.length))
                            message.lives = [];
                        message.lives.push($root.pb.Live.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                case 4: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.total = value;
                        else
                            delete message.total;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes an ActionResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pb.ActionResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pb.ActionResponse & pb.ActionResponse.$Shape} ActionResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActionResponse.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ActionResponse message.
         * @function verify
         * @memberof pb.ActionResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ActionResponse.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.items != null && $Object.hasOwnProperty.call(message, "items")) {
                if (!$Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.pb.ActionItem.verify(message.items[i], _depth + 1);
                    if (error)
                        return "items." + error;
                }
            }
            if (message.statistics != null && $Object.hasOwnProperty.call(message, "statistics")) {
                if (!$util.isObject(message.statistics))
                    return "statistics: object expected";
                let key = $Object.keys(message.statistics);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isString(message.statistics[key[i]]))
                        return "statistics: string{k:string} expected";
            }
            if (message.lives != null && $Object.hasOwnProperty.call(message, "lives")) {
                if (!$Array.isArray(message.lives))
                    return "lives: array expected";
                for (let i = 0; i < message.lives.length; ++i) {
                    let error = $root.pb.Live.verify(message.lives[i], _depth + 1);
                    if (error)
                        return "lives." + error;
                }
            }
            if (message.total != null && $Object.hasOwnProperty.call(message, "total"))
                if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                    return "total: integer|Long expected";
            return null;
        };

        /**
         * Creates an ActionResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pb.ActionResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pb.ActionResponse} ActionResponse
         */
        ActionResponse.fromObject = function (object, _depth) {
            if (object instanceof $root.pb.ActionResponse)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".pb.ActionResponse: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.pb.ActionResponse();
            if (object.items) {
                if (!$Array.isArray(object.items))
                    throw $TypeError(".pb.ActionResponse.items: array expected");
                message.items = $Array(object.items.length);
                for (let i = 0; i < object.items.length; ++i) {
                    if (!$util.isObject(object.items[i]))
                        throw $TypeError(".pb.ActionResponse.items: object expected");
                    message.items[i] = $root.pb.ActionItem.fromObject(object.items[i], _depth + 1);
                }
            }
            if (object.statistics) {
                if (!$util.isObject(object.statistics))
                    throw $TypeError(".pb.ActionResponse.statistics: object expected");
                message.statistics = {};
                for (let keys = $Object.keys(object.statistics), i = 0; i < keys.length; ++i) {
                    if (keys[i] === "__proto__")
                        $util.makeProp(message.statistics, keys[i]);
                    message.statistics[keys[i]] = $String(object.statistics[keys[i]]);
                }
            }
            if (object.lives) {
                if (!$Array.isArray(object.lives))
                    throw $TypeError(".pb.ActionResponse.lives: array expected");
                message.lives = $Array(object.lives.length);
                for (let i = 0; i < object.lives.length; ++i) {
                    if (!$util.isObject(object.lives[i]))
                        throw $TypeError(".pb.ActionResponse.lives: object expected");
                    message.lives[i] = $root.pb.Live.fromObject(object.lives[i], _depth + 1);
                }
            }
            if (object.total != null)
                if (typeof object.total === "object" ? object.total.low || object.total.high : $Number(object.total) !== 0)
                    if ($util.Long)
                        message.total = $util.Long.fromValue(object.total, false);
                    else if (typeof object.total === "string")
                        message.total = $parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an ActionResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pb.ActionResponse
         * @static
         * @param {pb.ActionResponse} message ActionResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ActionResponse.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.items = [];
                object.lives = [];
            }
            if (options.objects || options.defaults)
                object.statistics = {};
            if (options.defaults)
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.total = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.total = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            if (message.items && message.items.length) {
                object.items = $Array(message.items.length);
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.pb.ActionItem.toObject(message.items[j], options, _depth + 1);
            }
            let keys2;
            if (message.statistics && (keys2 = $Object.keys(message.statistics)).length) {
                object.statistics = {};
                for (let j = 0; j < keys2.length; ++j) {
                    if (keys2[j] === "__proto__")
                        $util.makeProp(object.statistics, keys2[j]);
                    object.statistics[keys2[j]] = message.statistics[keys2[j]];
                }
            }
            if (message.lives && message.lives.length) {
                object.lives = $Array(message.lives.length);
                for (let j = 0; j < message.lives.length; ++j)
                    object.lives[j] = $root.pb.Live.toObject(message.lives[j], options, _depth + 1);
            }
            if (message.total != null && $Object.hasOwnProperty.call(message, "total"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.total = typeof message.total === "number" ? $BigInt(message.total) : $util.Long.fromBits(message.total.low >>> 0, message.total.high >>> 0, false).toBigInt();
                else if (typeof message.total === "number")
                    object.total = options.longs === $String ? $String(message.total) : message.total;
                else
                    object.total = options.longs === $String ? $util.Long.prototype.toString.call(message.total) : options.longs === $Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
            return object;
        };

        /**
         * Converts this ActionResponse to JSON.
         * @function toJSON
         * @memberof pb.ActionResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ActionResponse.prototype.toJSON = function() {
            return ActionResponse.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ActionResponse
         * @function getTypeUrl
         * @memberof pb.ActionResponse
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ActionResponse.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/pb.ActionResponse";
        };

        return ActionResponse;
    })();

    pb.ActionItem = (function() {

        /**
         * Properties of an ActionItem.
         * @typedef {Object} pb.ActionItem.$Properties
         * @property {string|null} [action_name] ActionItem action_name
         * @property {number|null} [action_type] ActionItem action_type
         * @property {google.protobuf.Timestamp.$Properties|null} [created_at] ActionItem created_at
         * @property {Object.<string,string>|null} [emotes] ActionItem emotes
         * @property {string|null} [extra] ActionItem extra
         * @property {number|Long|null} [from_id] ActionItem from_id
         * @property {string|null} [from_name] ActionItem from_name
         * @property {number|null} [gift_amount] ActionItem gift_amount
         * @property {string|null} [gift_name] ActionItem gift_name
         * @property {number|null} [gift_price] ActionItem gift_price
         * @property {number|null} [guard_level] ActionItem guard_level
         * @property {number|Long|null} [hash] ActionItem hash
         * @property {number|null} [honor_level] ActionItem honor_level
         * @property {number|Long|null} [id] ActionItem id
         * @property {number|Long|null} [live] ActionItem live
         * @property {number|Long|null} [live_room] ActionItem live_room
         * @property {number|Long|null} [liver_id] ActionItem liver_id
         * @property {string|null} [liver_name] ActionItem liver_name
         * @property {number|null} [medal_level] ActionItem medal_level
         * @property {number|Long|null} [medal_liver] ActionItem medal_liver
         * @property {string|null} [medal_name] ActionItem medal_name
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an ActionItem.
         * @memberof pb
         * @interface IActionItem
         * @augments pb.ActionItem.$Properties
         * @deprecated Use pb.ActionItem.$Properties instead.
         */

        /**
         * Shape of an ActionItem.
         * @typedef {pb.ActionItem.$Properties} pb.ActionItem.$Shape
         */

        /**
         * Constructs a new ActionItem.
         * @memberof pb
         * @classdesc Represents an ActionItem.
         * @constructor
         * @param {pb.ActionItem.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const ActionItem = function (properties) {
            this.emotes = {};
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * ActionItem action_name.
         * @member {string} action_name
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.action_name = "";

        /**
         * ActionItem action_type.
         * @member {number} action_type
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.action_type = 0;

        /**
         * ActionItem created_at.
         * @member {google.protobuf.Timestamp.$Properties|null|undefined} created_at
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.created_at = null;

        /**
         * ActionItem emotes.
         * @member {Object.<string,string>} emotes
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.emotes = $util.emptyObject;

        /**
         * ActionItem extra.
         * @member {string} extra
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.extra = "";

        /**
         * ActionItem from_id.
         * @member {number|Long} from_id
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.from_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ActionItem from_name.
         * @member {string} from_name
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.from_name = "";

        /**
         * ActionItem gift_amount.
         * @member {number} gift_amount
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.gift_amount = 0;

        /**
         * ActionItem gift_name.
         * @member {string} gift_name
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.gift_name = "";

        /**
         * ActionItem gift_price.
         * @member {number} gift_price
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.gift_price = 0;

        /**
         * ActionItem guard_level.
         * @member {number} guard_level
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.guard_level = 0;

        /**
         * ActionItem hash.
         * @member {number|Long} hash
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.hash = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ActionItem honor_level.
         * @member {number} honor_level
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.honor_level = 0;

        /**
         * ActionItem id.
         * @member {number|Long} id
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ActionItem live.
         * @member {number|Long} live
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.live = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ActionItem live_room.
         * @member {number|Long} live_room
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.live_room = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ActionItem liver_id.
         * @member {number|Long} liver_id
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.liver_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ActionItem liver_name.
         * @member {string} liver_name
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.liver_name = "";

        /**
         * ActionItem medal_level.
         * @member {number} medal_level
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.medal_level = 0;

        /**
         * ActionItem medal_liver.
         * @member {number|Long} medal_liver
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.medal_liver = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ActionItem medal_name.
         * @member {string} medal_name
         * @memberof pb.ActionItem
         * @instance
         */
        ActionItem.prototype.medal_name = "";

        /**
         * Creates a new ActionItem instance using the specified properties.
         * @function create
         * @memberof pb.ActionItem
         * @static
         * @param {pb.ActionItem.$Properties=} [properties] Properties to set
         * @returns {pb.ActionItem} ActionItem instance
         * @type {{
         *   (properties: pb.ActionItem.$Shape): pb.ActionItem & pb.ActionItem.$Shape;
         *   (properties?: pb.ActionItem.$Properties): pb.ActionItem;
         * }}
         */
        ActionItem.create = function(properties) {
            return new ActionItem(properties);
        };

        /**
         * Encodes the specified ActionItem message. Does not implicitly {@link pb.ActionItem.verify|verify} messages.
         * @function encode
         * @memberof pb.ActionItem
         * @static
         * @param {pb.ActionItem.$Properties} message ActionItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActionItem.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.action_name != null && $Object.hasOwnProperty.call(message, "action_name") && message.action_name !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.action_name);
            if (message.action_type != null && $Object.hasOwnProperty.call(message, "action_type") && message.action_type !== 0)
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.action_type);
            if (message.created_at != null && $Object.hasOwnProperty.call(message, "created_at"))
                $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
            if (message.emotes != null && $Object.hasOwnProperty.call(message, "emotes"))
                for (let keys = $Object.keys(message.emotes), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.emotes[keys[i]]).ldelim();
            if (message.extra != null && $Object.hasOwnProperty.call(message, "extra") && message.extra !== "")
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.extra);
            if (message.from_id != null && $Object.hasOwnProperty.call(message, "from_id") && (typeof message.from_id === "object" ? message.from_id.low || message.from_id.high : message.from_id !== 0))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.from_id);
            if (message.from_name != null && $Object.hasOwnProperty.call(message, "from_name") && message.from_name !== "")
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.from_name);
            if (message.gift_amount != null && $Object.hasOwnProperty.call(message, "gift_amount") && message.gift_amount !== 0)
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.gift_amount);
            if (message.gift_name != null && $Object.hasOwnProperty.call(message, "gift_name") && message.gift_name !== "")
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.gift_name);
            if (message.gift_price != null && $Object.hasOwnProperty.call(message, "gift_price") && !$Object.is(message.gift_price, 0))
                writer.uint32(/* id 10, wireType 5 =*/85).float(message.gift_price);
            if (message.guard_level != null && $Object.hasOwnProperty.call(message, "guard_level") && message.guard_level !== 0)
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.guard_level);
            if (message.hash != null && $Object.hasOwnProperty.call(message, "hash") && (typeof message.hash === "object" ? message.hash.low || message.hash.high : message.hash !== 0))
                writer.uint32(/* id 12, wireType 0 =*/96).int64(message.hash);
            if (message.honor_level != null && $Object.hasOwnProperty.call(message, "honor_level") && message.honor_level !== 0)
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.honor_level);
            if (message.id != null && $Object.hasOwnProperty.call(message, "id") && (typeof message.id === "object" ? message.id.low || message.id.high : message.id !== 0))
                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.id);
            if (message.live != null && $Object.hasOwnProperty.call(message, "live") && (typeof message.live === "object" ? message.live.low || message.live.high : message.live !== 0))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.live);
            if (message.live_room != null && $Object.hasOwnProperty.call(message, "live_room") && (typeof message.live_room === "object" ? message.live_room.low || message.live_room.high : message.live_room !== 0))
                writer.uint32(/* id 16, wireType 0 =*/128).int64(message.live_room);
            if (message.liver_id != null && $Object.hasOwnProperty.call(message, "liver_id") && (typeof message.liver_id === "object" ? message.liver_id.low || message.liver_id.high : message.liver_id !== 0))
                writer.uint32(/* id 17, wireType 0 =*/136).int64(message.liver_id);
            if (message.liver_name != null && $Object.hasOwnProperty.call(message, "liver_name") && message.liver_name !== "")
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.liver_name);
            if (message.medal_level != null && $Object.hasOwnProperty.call(message, "medal_level") && message.medal_level !== 0)
                writer.uint32(/* id 19, wireType 0 =*/152).int32(message.medal_level);
            if (message.medal_liver != null && $Object.hasOwnProperty.call(message, "medal_liver") && (typeof message.medal_liver === "object" ? message.medal_liver.low || message.medal_liver.high : message.medal_liver !== 0))
                writer.uint32(/* id 20, wireType 0 =*/160).int64(message.medal_liver);
            if (message.medal_name != null && $Object.hasOwnProperty.call(message, "medal_name") && message.medal_name !== "")
                writer.uint32(/* id 21, wireType 2 =*/170).string(message.medal_name);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ActionItem message, length delimited. Does not implicitly {@link pb.ActionItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pb.ActionItem
         * @static
         * @param {pb.ActionItem.$Properties} message ActionItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActionItem.encodeDelimited = function(message, writer) {
            return this.encode(message, (writer || $Writer.create()).fork()).ldelim();
        };

        /**
         * Decodes an ActionItem message from the specified reader or buffer.
         * @function decode
         * @memberof pb.ActionItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pb.ActionItem & pb.ActionItem.$Shape} ActionItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActionItem.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, key, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.pb.ActionItem();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.action_name = value;
                        else
                            delete message.action_name;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.action_type = value;
                        else
                            delete message.action_type;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.created_at);
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if (message.emotes === $util.emptyObject)
                            message.emotes = {};
                        let end2 = reader.uint32() + reader.pos;
                        if (end2 > reader.len)
                            throw $RangeError("index out of range");
                        reader.len = end2;
                        key = "";
                        value = "";
                        while (reader.pos < end2) {
                            let tag2 = reader.tag();
                            wireType = tag2 & 7;
                            switch (tag2 >>>= 3) {
                            case 1:
                                if (wireType !== 2)
                                    break;
                                key = reader.stringVerify();
                                continue;
                            case 2:
                                if (wireType !== 2)
                                    break;
                                value = reader.stringVerify();
                                continue;
                            }
                            reader.skipType(wireType, _depth, tag2);
                        }
                        if (reader.pos !== end2)
                            throw $RangeError("index out of range");
                        reader.len = end;
                        if (key === "__proto__")
                            $util.makeProp(message.emotes, key);
                        message.emotes[key] = value;
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.extra = value;
                        else
                            delete message.extra;
                        continue;
                    }
                case 6: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.from_id = value;
                        else
                            delete message.from_id;
                        continue;
                    }
                case 7: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.from_name = value;
                        else
                            delete message.from_name;
                        continue;
                    }
                case 8: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.gift_amount = value;
                        else
                            delete message.gift_amount;
                        continue;
                    }
                case 9: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.gift_name = value;
                        else
                            delete message.gift_name;
                        continue;
                    }
                case 10: {
                        if (wireType !== 5)
                            break;
                        if (!$Object.is(value = reader.float(), 0))
                            message.gift_price = value;
                        else
                            delete message.gift_price;
                        continue;
                    }
                case 11: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.guard_level = value;
                        else
                            delete message.guard_level;
                        continue;
                    }
                case 12: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.hash = value;
                        else
                            delete message.hash;
                        continue;
                    }
                case 13: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.honor_level = value;
                        else
                            delete message.honor_level;
                        continue;
                    }
                case 14: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.id = value;
                        else
                            delete message.id;
                        continue;
                    }
                case 15: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.live = value;
                        else
                            delete message.live;
                        continue;
                    }
                case 16: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.live_room = value;
                        else
                            delete message.live_room;
                        continue;
                    }
                case 17: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.liver_id = value;
                        else
                            delete message.liver_id;
                        continue;
                    }
                case 18: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.liver_name = value;
                        else
                            delete message.liver_name;
                        continue;
                    }
                case 19: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.medal_level = value;
                        else
                            delete message.medal_level;
                        continue;
                    }
                case 20: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.medal_liver = value;
                        else
                            delete message.medal_liver;
                        continue;
                    }
                case 21: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.medal_name = value;
                        else
                            delete message.medal_name;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes an ActionItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pb.ActionItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pb.ActionItem & pb.ActionItem.$Shape} ActionItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActionItem.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ActionItem message.
         * @function verify
         * @memberof pb.ActionItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ActionItem.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.action_name != null && $Object.hasOwnProperty.call(message, "action_name"))
                if (!$util.isString(message.action_name))
                    return "action_name: string expected";
            if (message.action_type != null && $Object.hasOwnProperty.call(message, "action_type"))
                if (!$util.isInteger(message.action_type))
                    return "action_type: integer expected";
            if (message.created_at != null && $Object.hasOwnProperty.call(message, "created_at")) {
                let error = $root.google.protobuf.Timestamp.verify(message.created_at, _depth + 1);
                if (error)
                    return "created_at." + error;
            }
            if (message.emotes != null && $Object.hasOwnProperty.call(message, "emotes")) {
                if (!$util.isObject(message.emotes))
                    return "emotes: object expected";
                let key = $Object.keys(message.emotes);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isString(message.emotes[key[i]]))
                        return "emotes: string{k:string} expected";
            }
            if (message.extra != null && $Object.hasOwnProperty.call(message, "extra"))
                if (!$util.isString(message.extra))
                    return "extra: string expected";
            if (message.from_id != null && $Object.hasOwnProperty.call(message, "from_id"))
                if (!$util.isInteger(message.from_id) && !(message.from_id && $util.isInteger(message.from_id.low) && $util.isInteger(message.from_id.high)))
                    return "from_id: integer|Long expected";
            if (message.from_name != null && $Object.hasOwnProperty.call(message, "from_name"))
                if (!$util.isString(message.from_name))
                    return "from_name: string expected";
            if (message.gift_amount != null && $Object.hasOwnProperty.call(message, "gift_amount"))
                if (!$util.isInteger(message.gift_amount))
                    return "gift_amount: integer expected";
            if (message.gift_name != null && $Object.hasOwnProperty.call(message, "gift_name"))
                if (!$util.isString(message.gift_name))
                    return "gift_name: string expected";
            if (message.gift_price != null && $Object.hasOwnProperty.call(message, "gift_price"))
                if (typeof message.gift_price !== "number")
                    return "gift_price: number expected";
            if (message.guard_level != null && $Object.hasOwnProperty.call(message, "guard_level"))
                if (!$util.isInteger(message.guard_level))
                    return "guard_level: integer expected";
            if (message.hash != null && $Object.hasOwnProperty.call(message, "hash"))
                if (!$util.isInteger(message.hash) && !(message.hash && $util.isInteger(message.hash.low) && $util.isInteger(message.hash.high)))
                    return "hash: integer|Long expected";
            if (message.honor_level != null && $Object.hasOwnProperty.call(message, "honor_level"))
                if (!$util.isInteger(message.honor_level))
                    return "honor_level: integer expected";
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                    return "id: integer|Long expected";
            if (message.live != null && $Object.hasOwnProperty.call(message, "live"))
                if (!$util.isInteger(message.live) && !(message.live && $util.isInteger(message.live.low) && $util.isInteger(message.live.high)))
                    return "live: integer|Long expected";
            if (message.live_room != null && $Object.hasOwnProperty.call(message, "live_room"))
                if (!$util.isInteger(message.live_room) && !(message.live_room && $util.isInteger(message.live_room.low) && $util.isInteger(message.live_room.high)))
                    return "live_room: integer|Long expected";
            if (message.liver_id != null && $Object.hasOwnProperty.call(message, "liver_id"))
                if (!$util.isInteger(message.liver_id) && !(message.liver_id && $util.isInteger(message.liver_id.low) && $util.isInteger(message.liver_id.high)))
                    return "liver_id: integer|Long expected";
            if (message.liver_name != null && $Object.hasOwnProperty.call(message, "liver_name"))
                if (!$util.isString(message.liver_name))
                    return "liver_name: string expected";
            if (message.medal_level != null && $Object.hasOwnProperty.call(message, "medal_level"))
                if (!$util.isInteger(message.medal_level))
                    return "medal_level: integer expected";
            if (message.medal_liver != null && $Object.hasOwnProperty.call(message, "medal_liver"))
                if (!$util.isInteger(message.medal_liver) && !(message.medal_liver && $util.isInteger(message.medal_liver.low) && $util.isInteger(message.medal_liver.high)))
                    return "medal_liver: integer|Long expected";
            if (message.medal_name != null && $Object.hasOwnProperty.call(message, "medal_name"))
                if (!$util.isString(message.medal_name))
                    return "medal_name: string expected";
            return null;
        };

        /**
         * Creates an ActionItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pb.ActionItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pb.ActionItem} ActionItem
         */
        ActionItem.fromObject = function (object, _depth) {
            if (object instanceof $root.pb.ActionItem)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".pb.ActionItem: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.pb.ActionItem();
            if (object.action_name != null)
                if (typeof object.action_name !== "string" || object.action_name.length)
                    message.action_name = $String(object.action_name);
            if (object.action_type != null)
                if ($Number(object.action_type) !== 0)
                    message.action_type = object.action_type | 0;
            if (object.created_at != null) {
                if (!$util.isObject(object.created_at))
                    throw $TypeError(".pb.ActionItem.created_at: object expected");
                message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at, _depth + 1);
            }
            if (object.emotes) {
                if (!$util.isObject(object.emotes))
                    throw $TypeError(".pb.ActionItem.emotes: object expected");
                message.emotes = {};
                for (let keys = $Object.keys(object.emotes), i = 0; i < keys.length; ++i) {
                    if (keys[i] === "__proto__")
                        $util.makeProp(message.emotes, keys[i]);
                    message.emotes[keys[i]] = $String(object.emotes[keys[i]]);
                }
            }
            if (object.extra != null)
                if (typeof object.extra !== "string" || object.extra.length)
                    message.extra = $String(object.extra);
            if (object.from_id != null)
                if (typeof object.from_id === "object" ? object.from_id.low || object.from_id.high : $Number(object.from_id) !== 0)
                    if ($util.Long)
                        message.from_id = $util.Long.fromValue(object.from_id, false);
                    else if (typeof object.from_id === "string")
                        message.from_id = $parseInt(object.from_id, 10);
                    else if (typeof object.from_id === "number")
                        message.from_id = object.from_id;
                    else if (typeof object.from_id === "object")
                        message.from_id = new $util.LongBits(object.from_id.low >>> 0, object.from_id.high >>> 0).toNumber();
            if (object.from_name != null)
                if (typeof object.from_name !== "string" || object.from_name.length)
                    message.from_name = $String(object.from_name);
            if (object.gift_amount != null)
                if ($Number(object.gift_amount) !== 0)
                    message.gift_amount = object.gift_amount | 0;
            if (object.gift_name != null)
                if (typeof object.gift_name !== "string" || object.gift_name.length)
                    message.gift_name = $String(object.gift_name);
            if (object.gift_price != null)
                if (!$Object.is($Number(object.gift_price), 0))
                    message.gift_price = $Number(object.gift_price);
            if (object.guard_level != null)
                if ($Number(object.guard_level) !== 0)
                    message.guard_level = object.guard_level | 0;
            if (object.hash != null)
                if (typeof object.hash === "object" ? object.hash.low || object.hash.high : $Number(object.hash) !== 0)
                    if ($util.Long)
                        message.hash = $util.Long.fromValue(object.hash, false);
                    else if (typeof object.hash === "string")
                        message.hash = $parseInt(object.hash, 10);
                    else if (typeof object.hash === "number")
                        message.hash = object.hash;
                    else if (typeof object.hash === "object")
                        message.hash = new $util.LongBits(object.hash.low >>> 0, object.hash.high >>> 0).toNumber();
            if (object.honor_level != null)
                if ($Number(object.honor_level) !== 0)
                    message.honor_level = object.honor_level | 0;
            if (object.id != null)
                if (typeof object.id === "object" ? object.id.low || object.id.high : $Number(object.id) !== 0)
                    if ($util.Long)
                        message.id = $util.Long.fromValue(object.id, false);
                    else if (typeof object.id === "string")
                        message.id = $parseInt(object.id, 10);
                    else if (typeof object.id === "number")
                        message.id = object.id;
                    else if (typeof object.id === "object")
                        message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
            if (object.live != null)
                if (typeof object.live === "object" ? object.live.low || object.live.high : $Number(object.live) !== 0)
                    if ($util.Long)
                        message.live = $util.Long.fromValue(object.live, false);
                    else if (typeof object.live === "string")
                        message.live = $parseInt(object.live, 10);
                    else if (typeof object.live === "number")
                        message.live = object.live;
                    else if (typeof object.live === "object")
                        message.live = new $util.LongBits(object.live.low >>> 0, object.live.high >>> 0).toNumber();
            if (object.live_room != null)
                if (typeof object.live_room === "object" ? object.live_room.low || object.live_room.high : $Number(object.live_room) !== 0)
                    if ($util.Long)
                        message.live_room = $util.Long.fromValue(object.live_room, false);
                    else if (typeof object.live_room === "string")
                        message.live_room = $parseInt(object.live_room, 10);
                    else if (typeof object.live_room === "number")
                        message.live_room = object.live_room;
                    else if (typeof object.live_room === "object")
                        message.live_room = new $util.LongBits(object.live_room.low >>> 0, object.live_room.high >>> 0).toNumber();
            if (object.liver_id != null)
                if (typeof object.liver_id === "object" ? object.liver_id.low || object.liver_id.high : $Number(object.liver_id) !== 0)
                    if ($util.Long)
                        message.liver_id = $util.Long.fromValue(object.liver_id, false);
                    else if (typeof object.liver_id === "string")
                        message.liver_id = $parseInt(object.liver_id, 10);
                    else if (typeof object.liver_id === "number")
                        message.liver_id = object.liver_id;
                    else if (typeof object.liver_id === "object")
                        message.liver_id = new $util.LongBits(object.liver_id.low >>> 0, object.liver_id.high >>> 0).toNumber();
            if (object.liver_name != null)
                if (typeof object.liver_name !== "string" || object.liver_name.length)
                    message.liver_name = $String(object.liver_name);
            if (object.medal_level != null)
                if ($Number(object.medal_level) !== 0)
                    message.medal_level = object.medal_level | 0;
            if (object.medal_liver != null)
                if (typeof object.medal_liver === "object" ? object.medal_liver.low || object.medal_liver.high : $Number(object.medal_liver) !== 0)
                    if ($util.Long)
                        message.medal_liver = $util.Long.fromValue(object.medal_liver, false);
                    else if (typeof object.medal_liver === "string")
                        message.medal_liver = $parseInt(object.medal_liver, 10);
                    else if (typeof object.medal_liver === "number")
                        message.medal_liver = object.medal_liver;
                    else if (typeof object.medal_liver === "object")
                        message.medal_liver = new $util.LongBits(object.medal_liver.low >>> 0, object.medal_liver.high >>> 0).toNumber();
            if (object.medal_name != null)
                if (typeof object.medal_name !== "string" || object.medal_name.length)
                    message.medal_name = $String(object.medal_name);
            return message;
        };

        /**
         * Creates a plain object from an ActionItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pb.ActionItem
         * @static
         * @param {pb.ActionItem} message ActionItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ActionItem.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.objects || options.defaults)
                object.emotes = {};
            if (options.defaults) {
                object.action_name = "";
                object.action_type = 0;
                object.created_at = null;
                object.extra = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.from_id = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.from_id = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                object.from_name = "";
                object.gift_amount = 0;
                object.gift_name = "";
                object.gift_price = 0;
                object.guard_level = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.hash = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.hash = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                object.honor_level = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.id = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.id = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.live = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.live = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.live_room = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.live_room = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.liver_id = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.liver_id = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                object.liver_name = "";
                object.medal_level = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.medal_liver = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.medal_liver = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                object.medal_name = "";
            }
            if (message.action_name != null && $Object.hasOwnProperty.call(message, "action_name"))
                object.action_name = message.action_name;
            if (message.action_type != null && $Object.hasOwnProperty.call(message, "action_type"))
                object.action_type = message.action_type;
            if (message.created_at != null && $Object.hasOwnProperty.call(message, "created_at"))
                object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options, _depth + 1);
            let keys2;
            if (message.emotes && (keys2 = $Object.keys(message.emotes)).length) {
                object.emotes = {};
                for (let j = 0; j < keys2.length; ++j) {
                    if (keys2[j] === "__proto__")
                        $util.makeProp(object.emotes, keys2[j]);
                    object.emotes[keys2[j]] = message.emotes[keys2[j]];
                }
            }
            if (message.extra != null && $Object.hasOwnProperty.call(message, "extra"))
                object.extra = message.extra;
            if (message.from_id != null && $Object.hasOwnProperty.call(message, "from_id"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.from_id = typeof message.from_id === "number" ? $BigInt(message.from_id) : $util.Long.fromBits(message.from_id.low >>> 0, message.from_id.high >>> 0, false).toBigInt();
                else if (typeof message.from_id === "number")
                    object.from_id = options.longs === $String ? $String(message.from_id) : message.from_id;
                else
                    object.from_id = options.longs === $String ? $util.Long.prototype.toString.call(message.from_id) : options.longs === $Number ? new $util.LongBits(message.from_id.low >>> 0, message.from_id.high >>> 0).toNumber() : message.from_id;
            if (message.from_name != null && $Object.hasOwnProperty.call(message, "from_name"))
                object.from_name = message.from_name;
            if (message.gift_amount != null && $Object.hasOwnProperty.call(message, "gift_amount"))
                object.gift_amount = message.gift_amount;
            if (message.gift_name != null && $Object.hasOwnProperty.call(message, "gift_name"))
                object.gift_name = message.gift_name;
            if (message.gift_price != null && $Object.hasOwnProperty.call(message, "gift_price"))
                object.gift_price = options.json && !$isFinite(message.gift_price) ? $String(message.gift_price) : message.gift_price;
            if (message.guard_level != null && $Object.hasOwnProperty.call(message, "guard_level"))
                object.guard_level = message.guard_level;
            if (message.hash != null && $Object.hasOwnProperty.call(message, "hash"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.hash = typeof message.hash === "number" ? $BigInt(message.hash) : $util.Long.fromBits(message.hash.low >>> 0, message.hash.high >>> 0, false).toBigInt();
                else if (typeof message.hash === "number")
                    object.hash = options.longs === $String ? $String(message.hash) : message.hash;
                else
                    object.hash = options.longs === $String ? $util.Long.prototype.toString.call(message.hash) : options.longs === $Number ? new $util.LongBits(message.hash.low >>> 0, message.hash.high >>> 0).toNumber() : message.hash;
            if (message.honor_level != null && $Object.hasOwnProperty.call(message, "honor_level"))
                object.honor_level = message.honor_level;
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.id = typeof message.id === "number" ? $BigInt(message.id) : $util.Long.fromBits(message.id.low >>> 0, message.id.high >>> 0, false).toBigInt();
                else if (typeof message.id === "number")
                    object.id = options.longs === $String ? $String(message.id) : message.id;
                else
                    object.id = options.longs === $String ? $util.Long.prototype.toString.call(message.id) : options.longs === $Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
            if (message.live != null && $Object.hasOwnProperty.call(message, "live"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.live = typeof message.live === "number" ? $BigInt(message.live) : $util.Long.fromBits(message.live.low >>> 0, message.live.high >>> 0, false).toBigInt();
                else if (typeof message.live === "number")
                    object.live = options.longs === $String ? $String(message.live) : message.live;
                else
                    object.live = options.longs === $String ? $util.Long.prototype.toString.call(message.live) : options.longs === $Number ? new $util.LongBits(message.live.low >>> 0, message.live.high >>> 0).toNumber() : message.live;
            if (message.live_room != null && $Object.hasOwnProperty.call(message, "live_room"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.live_room = typeof message.live_room === "number" ? $BigInt(message.live_room) : $util.Long.fromBits(message.live_room.low >>> 0, message.live_room.high >>> 0, false).toBigInt();
                else if (typeof message.live_room === "number")
                    object.live_room = options.longs === $String ? $String(message.live_room) : message.live_room;
                else
                    object.live_room = options.longs === $String ? $util.Long.prototype.toString.call(message.live_room) : options.longs === $Number ? new $util.LongBits(message.live_room.low >>> 0, message.live_room.high >>> 0).toNumber() : message.live_room;
            if (message.liver_id != null && $Object.hasOwnProperty.call(message, "liver_id"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.liver_id = typeof message.liver_id === "number" ? $BigInt(message.liver_id) : $util.Long.fromBits(message.liver_id.low >>> 0, message.liver_id.high >>> 0, false).toBigInt();
                else if (typeof message.liver_id === "number")
                    object.liver_id = options.longs === $String ? $String(message.liver_id) : message.liver_id;
                else
                    object.liver_id = options.longs === $String ? $util.Long.prototype.toString.call(message.liver_id) : options.longs === $Number ? new $util.LongBits(message.liver_id.low >>> 0, message.liver_id.high >>> 0).toNumber() : message.liver_id;
            if (message.liver_name != null && $Object.hasOwnProperty.call(message, "liver_name"))
                object.liver_name = message.liver_name;
            if (message.medal_level != null && $Object.hasOwnProperty.call(message, "medal_level"))
                object.medal_level = message.medal_level;
            if (message.medal_liver != null && $Object.hasOwnProperty.call(message, "medal_liver"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.medal_liver = typeof message.medal_liver === "number" ? $BigInt(message.medal_liver) : $util.Long.fromBits(message.medal_liver.low >>> 0, message.medal_liver.high >>> 0, false).toBigInt();
                else if (typeof message.medal_liver === "number")
                    object.medal_liver = options.longs === $String ? $String(message.medal_liver) : message.medal_liver;
                else
                    object.medal_liver = options.longs === $String ? $util.Long.prototype.toString.call(message.medal_liver) : options.longs === $Number ? new $util.LongBits(message.medal_liver.low >>> 0, message.medal_liver.high >>> 0).toNumber() : message.medal_liver;
            if (message.medal_name != null && $Object.hasOwnProperty.call(message, "medal_name"))
                object.medal_name = message.medal_name;
            return object;
        };

        /**
         * Converts this ActionItem to JSON.
         * @function toJSON
         * @memberof pb.ActionItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ActionItem.prototype.toJSON = function() {
            return ActionItem.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ActionItem
         * @function getTypeUrl
         * @memberof pb.ActionItem
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ActionItem.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/pb.ActionItem";
        };

        return ActionItem;
    })();

    pb.Live = (function() {

        /**
         * Properties of a Live.
         * @typedef {Object} pb.Live.$Properties
         * @property {string|null} [area] Live area
         * @property {number|null} [area_id] Live area_id
         * @property {number|null} [box_diff] Live box_diff
         * @property {string|null} [cover] Live cover
         * @property {string|null} [created_at] Live created_at
         * @property {number|Long|null} [end_at] Live end_at
         * @property {number|null} [guard_money] Live guard_money
         * @property {number|Long|null} [id] Live id
         * @property {string|null} [label] Live label
         * @property {number|null} [message] Live message
         * @property {number|null} [money] Live money
         * @property {number|null} [parent_area_id] Live parent_area_id
         * @property {number|Long|null} [room_id] Live room_id
         * @property {number|Long|null} [start_at] Live start_at
         * @property {number|null} [super_chat_money] Live super_chat_money
         * @property {string|null} [title] Live title
         * @property {string|null} [updated_at] Live updated_at
         * @property {string|null} [user_id] Live user_id
         * @property {number|Long|null} [user_id_num] Live user_id_num
         * @property {string|null} [user_name] Live user_name
         * @property {number|null} [watch] Live watch
         * @property {Array.<pb.OnlineStatus.$Properties>|null} [online] Live online
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Live.
         * @memberof pb
         * @interface ILive
         * @augments pb.Live.$Properties
         * @deprecated Use pb.Live.$Properties instead.
         */

        /**
         * Shape of a Live.
         * @typedef {pb.Live.$Properties} pb.Live.$Shape
         */

        /**
         * Constructs a new Live.
         * @memberof pb
         * @classdesc Represents a Live.
         * @constructor
         * @param {pb.Live.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Live = function (properties) {
            this.online = [];
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Live area.
         * @member {string} area
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.area = "";

        /**
         * Live area_id.
         * @member {number} area_id
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.area_id = 0;

        /**
         * Live box_diff.
         * @member {number} box_diff
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.box_diff = 0;

        /**
         * Live cover.
         * @member {string} cover
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.cover = "";

        /**
         * Live created_at.
         * @member {string} created_at
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.created_at = "";

        /**
         * Live end_at.
         * @member {number|Long} end_at
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.end_at = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Live guard_money.
         * @member {number} guard_money
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.guard_money = 0;

        /**
         * Live id.
         * @member {number|Long} id
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Live label.
         * @member {string} label
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.label = "";

        /**
         * Live message.
         * @member {number} message
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.message = 0;

        /**
         * Live money.
         * @member {number} money
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.money = 0;

        /**
         * Live parent_area_id.
         * @member {number} parent_area_id
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.parent_area_id = 0;

        /**
         * Live room_id.
         * @member {number|Long} room_id
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.room_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Live start_at.
         * @member {number|Long} start_at
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.start_at = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Live super_chat_money.
         * @member {number} super_chat_money
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.super_chat_money = 0;

        /**
         * Live title.
         * @member {string} title
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.title = "";

        /**
         * Live updated_at.
         * @member {string} updated_at
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.updated_at = "";

        /**
         * Live user_id.
         * @member {string} user_id
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.user_id = "";

        /**
         * Live user_id_num.
         * @member {number|Long} user_id_num
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.user_id_num = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Live user_name.
         * @member {string} user_name
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.user_name = "";

        /**
         * Live watch.
         * @member {number} watch
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.watch = 0;

        /**
         * Live online.
         * @member {Array.<pb.OnlineStatus.$Properties>} online
         * @memberof pb.Live
         * @instance
         */
        Live.prototype.online = $util.emptyArray;

        /**
         * Creates a new Live instance using the specified properties.
         * @function create
         * @memberof pb.Live
         * @static
         * @param {pb.Live.$Properties=} [properties] Properties to set
         * @returns {pb.Live} Live instance
         * @type {{
         *   (properties: pb.Live.$Shape): pb.Live & pb.Live.$Shape;
         *   (properties?: pb.Live.$Properties): pb.Live;
         * }}
         */
        Live.create = function(properties) {
            return new Live(properties);
        };

        /**
         * Encodes the specified Live message. Does not implicitly {@link pb.Live.verify|verify} messages.
         * @function encode
         * @memberof pb.Live
         * @static
         * @param {pb.Live.$Properties} message Live message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Live.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.area != null && $Object.hasOwnProperty.call(message, "area") && message.area !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.area);
            if (message.area_id != null && $Object.hasOwnProperty.call(message, "area_id") && message.area_id !== 0)
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.area_id);
            if (message.box_diff != null && $Object.hasOwnProperty.call(message, "box_diff") && message.box_diff !== 0)
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.box_diff);
            if (message.cover != null && $Object.hasOwnProperty.call(message, "cover") && message.cover !== "")
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.cover);
            if (message.created_at != null && $Object.hasOwnProperty.call(message, "created_at") && message.created_at !== "")
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.created_at);
            if (message.end_at != null && $Object.hasOwnProperty.call(message, "end_at") && (typeof message.end_at === "object" ? message.end_at.low || message.end_at.high : message.end_at !== 0))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.end_at);
            if (message.guard_money != null && $Object.hasOwnProperty.call(message, "guard_money") && !$Object.is(message.guard_money, 0))
                writer.uint32(/* id 8, wireType 1 =*/65).double(message.guard_money);
            if (message.id != null && $Object.hasOwnProperty.call(message, "id") && (typeof message.id === "object" ? message.id.low || message.id.high : message.id !== 0))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.id);
            if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.label);
            if (message.message != null && $Object.hasOwnProperty.call(message, "message") && message.message !== 0)
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.message);
            if (message.money != null && $Object.hasOwnProperty.call(message, "money") && !$Object.is(message.money, 0))
                writer.uint32(/* id 12, wireType 1 =*/97).double(message.money);
            if (message.parent_area_id != null && $Object.hasOwnProperty.call(message, "parent_area_id") && message.parent_area_id !== 0)
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.parent_area_id);
            if (message.room_id != null && $Object.hasOwnProperty.call(message, "room_id") && (typeof message.room_id === "object" ? message.room_id.low || message.room_id.high : message.room_id !== 0))
                writer.uint32(/* id 16, wireType 0 =*/128).int64(message.room_id);
            if (message.start_at != null && $Object.hasOwnProperty.call(message, "start_at") && (typeof message.start_at === "object" ? message.start_at.low || message.start_at.high : message.start_at !== 0))
                writer.uint32(/* id 17, wireType 0 =*/136).int64(message.start_at);
            if (message.super_chat_money != null && $Object.hasOwnProperty.call(message, "super_chat_money") && !$Object.is(message.super_chat_money, 0))
                writer.uint32(/* id 18, wireType 1 =*/145).double(message.super_chat_money);
            if (message.title != null && $Object.hasOwnProperty.call(message, "title") && message.title !== "")
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.title);
            if (message.updated_at != null && $Object.hasOwnProperty.call(message, "updated_at") && message.updated_at !== "")
                writer.uint32(/* id 20, wireType 2 =*/162).string(message.updated_at);
            if (message.user_id != null && $Object.hasOwnProperty.call(message, "user_id") && message.user_id !== "")
                writer.uint32(/* id 21, wireType 2 =*/170).string(message.user_id);
            if (message.user_id_num != null && $Object.hasOwnProperty.call(message, "user_id_num") && (typeof message.user_id_num === "object" ? message.user_id_num.low || message.user_id_num.high : message.user_id_num !== 0))
                writer.uint32(/* id 22, wireType 0 =*/176).int64(message.user_id_num);
            if (message.user_name != null && $Object.hasOwnProperty.call(message, "user_name") && message.user_name !== "")
                writer.uint32(/* id 23, wireType 2 =*/186).string(message.user_name);
            if (message.watch != null && $Object.hasOwnProperty.call(message, "watch") && message.watch !== 0)
                writer.uint32(/* id 24, wireType 0 =*/192).int32(message.watch);
            if (message.online != null && message.online.length)
                for (let i = 0; i < message.online.length; ++i)
                    $root.pb.OnlineStatus.encode(message.online[i], writer.uint32(/* id 25, wireType 2 =*/202).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Live message, length delimited. Does not implicitly {@link pb.Live.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pb.Live
         * @static
         * @param {pb.Live.$Properties} message Live message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Live.encodeDelimited = function(message, writer) {
            return this.encode(message, (writer || $Writer.create()).fork()).ldelim();
        };

        /**
         * Decodes a Live message from the specified reader or buffer.
         * @function decode
         * @memberof pb.Live
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pb.Live & pb.Live.$Shape} Live
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Live.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.pb.Live();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.area = value;
                        else
                            delete message.area;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.area_id = value;
                        else
                            delete message.area_id;
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.box_diff = value;
                        else
                            delete message.box_diff;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.cover = value;
                        else
                            delete message.cover;
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.created_at = value;
                        else
                            delete message.created_at;
                        continue;
                    }
                case 7: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.end_at = value;
                        else
                            delete message.end_at;
                        continue;
                    }
                case 8: {
                        if (wireType !== 1)
                            break;
                        if (!$Object.is(value = reader.double(), 0))
                            message.guard_money = value;
                        else
                            delete message.guard_money;
                        continue;
                    }
                case 9: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.id = value;
                        else
                            delete message.id;
                        continue;
                    }
                case 10: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.label = value;
                        else
                            delete message.label;
                        continue;
                    }
                case 11: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.message = value;
                        else
                            delete message.message;
                        continue;
                    }
                case 12: {
                        if (wireType !== 1)
                            break;
                        if (!$Object.is(value = reader.double(), 0))
                            message.money = value;
                        else
                            delete message.money;
                        continue;
                    }
                case 15: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.parent_area_id = value;
                        else
                            delete message.parent_area_id;
                        continue;
                    }
                case 16: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.room_id = value;
                        else
                            delete message.room_id;
                        continue;
                    }
                case 17: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.start_at = value;
                        else
                            delete message.start_at;
                        continue;
                    }
                case 18: {
                        if (wireType !== 1)
                            break;
                        if (!$Object.is(value = reader.double(), 0))
                            message.super_chat_money = value;
                        else
                            delete message.super_chat_money;
                        continue;
                    }
                case 19: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.title = value;
                        else
                            delete message.title;
                        continue;
                    }
                case 20: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.updated_at = value;
                        else
                            delete message.updated_at;
                        continue;
                    }
                case 21: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.user_id = value;
                        else
                            delete message.user_id;
                        continue;
                    }
                case 22: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                            message.user_id_num = value;
                        else
                            delete message.user_id_num;
                        continue;
                    }
                case 23: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.user_name = value;
                        else
                            delete message.user_name;
                        continue;
                    }
                case 24: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.watch = value;
                        else
                            delete message.watch;
                        continue;
                    }
                case 25: {
                        if (wireType !== 2)
                            break;
                        if (!(message.online && message.online.length))
                            message.online = [];
                        message.online.push($root.pb.OnlineStatus.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a Live message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pb.Live
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pb.Live & pb.Live.$Shape} Live
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Live.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Live message.
         * @function verify
         * @memberof pb.Live
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Live.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.area != null && $Object.hasOwnProperty.call(message, "area"))
                if (!$util.isString(message.area))
                    return "area: string expected";
            if (message.area_id != null && $Object.hasOwnProperty.call(message, "area_id"))
                if (!$util.isInteger(message.area_id))
                    return "area_id: integer expected";
            if (message.box_diff != null && $Object.hasOwnProperty.call(message, "box_diff"))
                if (!$util.isInteger(message.box_diff))
                    return "box_diff: integer expected";
            if (message.cover != null && $Object.hasOwnProperty.call(message, "cover"))
                if (!$util.isString(message.cover))
                    return "cover: string expected";
            if (message.created_at != null && $Object.hasOwnProperty.call(message, "created_at"))
                if (!$util.isString(message.created_at))
                    return "created_at: string expected";
            if (message.end_at != null && $Object.hasOwnProperty.call(message, "end_at"))
                if (!$util.isInteger(message.end_at) && !(message.end_at && $util.isInteger(message.end_at.low) && $util.isInteger(message.end_at.high)))
                    return "end_at: integer|Long expected";
            if (message.guard_money != null && $Object.hasOwnProperty.call(message, "guard_money"))
                if (typeof message.guard_money !== "number")
                    return "guard_money: number expected";
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                    return "id: integer|Long expected";
            if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
                if (!$util.isString(message.label))
                    return "label: string expected";
            if (message.message != null && $Object.hasOwnProperty.call(message, "message"))
                if (!$util.isInteger(message.message))
                    return "message: integer expected";
            if (message.money != null && $Object.hasOwnProperty.call(message, "money"))
                if (typeof message.money !== "number")
                    return "money: number expected";
            if (message.parent_area_id != null && $Object.hasOwnProperty.call(message, "parent_area_id"))
                if (!$util.isInteger(message.parent_area_id))
                    return "parent_area_id: integer expected";
            if (message.room_id != null && $Object.hasOwnProperty.call(message, "room_id"))
                if (!$util.isInteger(message.room_id) && !(message.room_id && $util.isInteger(message.room_id.low) && $util.isInteger(message.room_id.high)))
                    return "room_id: integer|Long expected";
            if (message.start_at != null && $Object.hasOwnProperty.call(message, "start_at"))
                if (!$util.isInteger(message.start_at) && !(message.start_at && $util.isInteger(message.start_at.low) && $util.isInteger(message.start_at.high)))
                    return "start_at: integer|Long expected";
            if (message.super_chat_money != null && $Object.hasOwnProperty.call(message, "super_chat_money"))
                if (typeof message.super_chat_money !== "number")
                    return "super_chat_money: number expected";
            if (message.title != null && $Object.hasOwnProperty.call(message, "title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.updated_at != null && $Object.hasOwnProperty.call(message, "updated_at"))
                if (!$util.isString(message.updated_at))
                    return "updated_at: string expected";
            if (message.user_id != null && $Object.hasOwnProperty.call(message, "user_id"))
                if (!$util.isString(message.user_id))
                    return "user_id: string expected";
            if (message.user_id_num != null && $Object.hasOwnProperty.call(message, "user_id_num"))
                if (!$util.isInteger(message.user_id_num) && !(message.user_id_num && $util.isInteger(message.user_id_num.low) && $util.isInteger(message.user_id_num.high)))
                    return "user_id_num: integer|Long expected";
            if (message.user_name != null && $Object.hasOwnProperty.call(message, "user_name"))
                if (!$util.isString(message.user_name))
                    return "user_name: string expected";
            if (message.watch != null && $Object.hasOwnProperty.call(message, "watch"))
                if (!$util.isInteger(message.watch))
                    return "watch: integer expected";
            if (message.online != null && $Object.hasOwnProperty.call(message, "online")) {
                if (!$Array.isArray(message.online))
                    return "online: array expected";
                for (let i = 0; i < message.online.length; ++i) {
                    let error = $root.pb.OnlineStatus.verify(message.online[i], _depth + 1);
                    if (error)
                        return "online." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Live message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pb.Live
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pb.Live} Live
         */
        Live.fromObject = function (object, _depth) {
            if (object instanceof $root.pb.Live)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".pb.Live: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.pb.Live();
            if (object.area != null)
                if (typeof object.area !== "string" || object.area.length)
                    message.area = $String(object.area);
            if (object.area_id != null)
                if ($Number(object.area_id) !== 0)
                    message.area_id = object.area_id | 0;
            if (object.box_diff != null)
                if ($Number(object.box_diff) !== 0)
                    message.box_diff = object.box_diff | 0;
            if (object.cover != null)
                if (typeof object.cover !== "string" || object.cover.length)
                    message.cover = $String(object.cover);
            if (object.created_at != null)
                if (typeof object.created_at !== "string" || object.created_at.length)
                    message.created_at = $String(object.created_at);
            if (object.end_at != null)
                if (typeof object.end_at === "object" ? object.end_at.low || object.end_at.high : $Number(object.end_at) !== 0)
                    if ($util.Long)
                        message.end_at = $util.Long.fromValue(object.end_at, false);
                    else if (typeof object.end_at === "string")
                        message.end_at = $parseInt(object.end_at, 10);
                    else if (typeof object.end_at === "number")
                        message.end_at = object.end_at;
                    else if (typeof object.end_at === "object")
                        message.end_at = new $util.LongBits(object.end_at.low >>> 0, object.end_at.high >>> 0).toNumber();
            if (object.guard_money != null)
                if (!$Object.is($Number(object.guard_money), 0))
                    message.guard_money = $Number(object.guard_money);
            if (object.id != null)
                if (typeof object.id === "object" ? object.id.low || object.id.high : $Number(object.id) !== 0)
                    if ($util.Long)
                        message.id = $util.Long.fromValue(object.id, false);
                    else if (typeof object.id === "string")
                        message.id = $parseInt(object.id, 10);
                    else if (typeof object.id === "number")
                        message.id = object.id;
                    else if (typeof object.id === "object")
                        message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
            if (object.label != null)
                if (typeof object.label !== "string" || object.label.length)
                    message.label = $String(object.label);
            if (object.message != null)
                if ($Number(object.message) !== 0)
                    message.message = object.message | 0;
            if (object.money != null)
                if (!$Object.is($Number(object.money), 0))
                    message.money = $Number(object.money);
            if (object.parent_area_id != null)
                if ($Number(object.parent_area_id) !== 0)
                    message.parent_area_id = object.parent_area_id | 0;
            if (object.room_id != null)
                if (typeof object.room_id === "object" ? object.room_id.low || object.room_id.high : $Number(object.room_id) !== 0)
                    if ($util.Long)
                        message.room_id = $util.Long.fromValue(object.room_id, false);
                    else if (typeof object.room_id === "string")
                        message.room_id = $parseInt(object.room_id, 10);
                    else if (typeof object.room_id === "number")
                        message.room_id = object.room_id;
                    else if (typeof object.room_id === "object")
                        message.room_id = new $util.LongBits(object.room_id.low >>> 0, object.room_id.high >>> 0).toNumber();
            if (object.start_at != null)
                if (typeof object.start_at === "object" ? object.start_at.low || object.start_at.high : $Number(object.start_at) !== 0)
                    if ($util.Long)
                        message.start_at = $util.Long.fromValue(object.start_at, false);
                    else if (typeof object.start_at === "string")
                        message.start_at = $parseInt(object.start_at, 10);
                    else if (typeof object.start_at === "number")
                        message.start_at = object.start_at;
                    else if (typeof object.start_at === "object")
                        message.start_at = new $util.LongBits(object.start_at.low >>> 0, object.start_at.high >>> 0).toNumber();
            if (object.super_chat_money != null)
                if (!$Object.is($Number(object.super_chat_money), 0))
                    message.super_chat_money = $Number(object.super_chat_money);
            if (object.title != null)
                if (typeof object.title !== "string" || object.title.length)
                    message.title = $String(object.title);
            if (object.updated_at != null)
                if (typeof object.updated_at !== "string" || object.updated_at.length)
                    message.updated_at = $String(object.updated_at);
            if (object.user_id != null)
                if (typeof object.user_id !== "string" || object.user_id.length)
                    message.user_id = $String(object.user_id);
            if (object.user_id_num != null)
                if (typeof object.user_id_num === "object" ? object.user_id_num.low || object.user_id_num.high : $Number(object.user_id_num) !== 0)
                    if ($util.Long)
                        message.user_id_num = $util.Long.fromValue(object.user_id_num, false);
                    else if (typeof object.user_id_num === "string")
                        message.user_id_num = $parseInt(object.user_id_num, 10);
                    else if (typeof object.user_id_num === "number")
                        message.user_id_num = object.user_id_num;
                    else if (typeof object.user_id_num === "object")
                        message.user_id_num = new $util.LongBits(object.user_id_num.low >>> 0, object.user_id_num.high >>> 0).toNumber();
            if (object.user_name != null)
                if (typeof object.user_name !== "string" || object.user_name.length)
                    message.user_name = $String(object.user_name);
            if (object.watch != null)
                if ($Number(object.watch) !== 0)
                    message.watch = object.watch | 0;
            if (object.online) {
                if (!$Array.isArray(object.online))
                    throw $TypeError(".pb.Live.online: array expected");
                message.online = $Array(object.online.length);
                for (let i = 0; i < object.online.length; ++i) {
                    if (!$util.isObject(object.online[i]))
                        throw $TypeError(".pb.Live.online: object expected");
                    message.online[i] = $root.pb.OnlineStatus.fromObject(object.online[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Live message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pb.Live
         * @static
         * @param {pb.Live} message Live
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Live.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.online = [];
            if (options.defaults) {
                object.area = "";
                object.area_id = 0;
                object.box_diff = 0;
                object.cover = "";
                object.created_at = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.end_at = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.end_at = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                object.guard_money = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.id = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.id = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                object.label = "";
                object.message = 0;
                object.money = 0;
                object.parent_area_id = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.room_id = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.room_id = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.start_at = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.start_at = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                object.super_chat_money = 0;
                object.title = "";
                object.updated_at = "";
                object.user_id = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.user_id_num = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.user_id_num = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                object.user_name = "";
                object.watch = 0;
            }
            if (message.area != null && $Object.hasOwnProperty.call(message, "area"))
                object.area = message.area;
            if (message.area_id != null && $Object.hasOwnProperty.call(message, "area_id"))
                object.area_id = message.area_id;
            if (message.box_diff != null && $Object.hasOwnProperty.call(message, "box_diff"))
                object.box_diff = message.box_diff;
            if (message.cover != null && $Object.hasOwnProperty.call(message, "cover"))
                object.cover = message.cover;
            if (message.created_at != null && $Object.hasOwnProperty.call(message, "created_at"))
                object.created_at = message.created_at;
            if (message.end_at != null && $Object.hasOwnProperty.call(message, "end_at"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.end_at = typeof message.end_at === "number" ? $BigInt(message.end_at) : $util.Long.fromBits(message.end_at.low >>> 0, message.end_at.high >>> 0, false).toBigInt();
                else if (typeof message.end_at === "number")
                    object.end_at = options.longs === $String ? $String(message.end_at) : message.end_at;
                else
                    object.end_at = options.longs === $String ? $util.Long.prototype.toString.call(message.end_at) : options.longs === $Number ? new $util.LongBits(message.end_at.low >>> 0, message.end_at.high >>> 0).toNumber() : message.end_at;
            if (message.guard_money != null && $Object.hasOwnProperty.call(message, "guard_money"))
                object.guard_money = options.json && !$isFinite(message.guard_money) ? $String(message.guard_money) : message.guard_money;
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.id = typeof message.id === "number" ? $BigInt(message.id) : $util.Long.fromBits(message.id.low >>> 0, message.id.high >>> 0, false).toBigInt();
                else if (typeof message.id === "number")
                    object.id = options.longs === $String ? $String(message.id) : message.id;
                else
                    object.id = options.longs === $String ? $util.Long.prototype.toString.call(message.id) : options.longs === $Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
            if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
                object.label = message.label;
            if (message.message != null && $Object.hasOwnProperty.call(message, "message"))
                object.message = message.message;
            if (message.money != null && $Object.hasOwnProperty.call(message, "money"))
                object.money = options.json && !$isFinite(message.money) ? $String(message.money) : message.money;
            if (message.parent_area_id != null && $Object.hasOwnProperty.call(message, "parent_area_id"))
                object.parent_area_id = message.parent_area_id;
            if (message.room_id != null && $Object.hasOwnProperty.call(message, "room_id"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.room_id = typeof message.room_id === "number" ? $BigInt(message.room_id) : $util.Long.fromBits(message.room_id.low >>> 0, message.room_id.high >>> 0, false).toBigInt();
                else if (typeof message.room_id === "number")
                    object.room_id = options.longs === $String ? $String(message.room_id) : message.room_id;
                else
                    object.room_id = options.longs === $String ? $util.Long.prototype.toString.call(message.room_id) : options.longs === $Number ? new $util.LongBits(message.room_id.low >>> 0, message.room_id.high >>> 0).toNumber() : message.room_id;
            if (message.start_at != null && $Object.hasOwnProperty.call(message, "start_at"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.start_at = typeof message.start_at === "number" ? $BigInt(message.start_at) : $util.Long.fromBits(message.start_at.low >>> 0, message.start_at.high >>> 0, false).toBigInt();
                else if (typeof message.start_at === "number")
                    object.start_at = options.longs === $String ? $String(message.start_at) : message.start_at;
                else
                    object.start_at = options.longs === $String ? $util.Long.prototype.toString.call(message.start_at) : options.longs === $Number ? new $util.LongBits(message.start_at.low >>> 0, message.start_at.high >>> 0).toNumber() : message.start_at;
            if (message.super_chat_money != null && $Object.hasOwnProperty.call(message, "super_chat_money"))
                object.super_chat_money = options.json && !$isFinite(message.super_chat_money) ? $String(message.super_chat_money) : message.super_chat_money;
            if (message.title != null && $Object.hasOwnProperty.call(message, "title"))
                object.title = message.title;
            if (message.updated_at != null && $Object.hasOwnProperty.call(message, "updated_at"))
                object.updated_at = message.updated_at;
            if (message.user_id != null && $Object.hasOwnProperty.call(message, "user_id"))
                object.user_id = message.user_id;
            if (message.user_id_num != null && $Object.hasOwnProperty.call(message, "user_id_num"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.user_id_num = typeof message.user_id_num === "number" ? $BigInt(message.user_id_num) : $util.Long.fromBits(message.user_id_num.low >>> 0, message.user_id_num.high >>> 0, false).toBigInt();
                else if (typeof message.user_id_num === "number")
                    object.user_id_num = options.longs === $String ? $String(message.user_id_num) : message.user_id_num;
                else
                    object.user_id_num = options.longs === $String ? $util.Long.prototype.toString.call(message.user_id_num) : options.longs === $Number ? new $util.LongBits(message.user_id_num.low >>> 0, message.user_id_num.high >>> 0).toNumber() : message.user_id_num;
            if (message.user_name != null && $Object.hasOwnProperty.call(message, "user_name"))
                object.user_name = message.user_name;
            if (message.watch != null && $Object.hasOwnProperty.call(message, "watch"))
                object.watch = message.watch;
            if (message.online && message.online.length) {
                object.online = $Array(message.online.length);
                for (let j = 0; j < message.online.length; ++j)
                    object.online[j] = $root.pb.OnlineStatus.toObject(message.online[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this Live to JSON.
         * @function toJSON
         * @memberof pb.Live
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Live.prototype.toJSON = function() {
            return Live.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Live
         * @function getTypeUrl
         * @memberof pb.Live
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Live.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/pb.Live";
        };

        return Live;
    })();

    pb.OnlineStatus = (function() {

        /**
         * Properties of an OnlineStatus.
         * @typedef {Object} pb.OnlineStatus.$Properties
         * @property {google.protobuf.Timestamp.$Properties|null} [created_at] OnlineStatus created_at
         * @property {string|null} [type] OnlineStatus type
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an OnlineStatus.
         * @memberof pb
         * @interface IOnlineStatus
         * @augments pb.OnlineStatus.$Properties
         * @deprecated Use pb.OnlineStatus.$Properties instead.
         */

        /**
         * Shape of an OnlineStatus.
         * @typedef {pb.OnlineStatus.$Properties} pb.OnlineStatus.$Shape
         */

        /**
         * Constructs a new OnlineStatus.
         * @memberof pb
         * @classdesc Represents an OnlineStatus.
         * @constructor
         * @param {pb.OnlineStatus.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const OnlineStatus = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * OnlineStatus created_at.
         * @member {google.protobuf.Timestamp.$Properties|null|undefined} created_at
         * @memberof pb.OnlineStatus
         * @instance
         */
        OnlineStatus.prototype.created_at = null;

        /**
         * OnlineStatus type.
         * @member {string} type
         * @memberof pb.OnlineStatus
         * @instance
         */
        OnlineStatus.prototype.type = "";

        /**
         * Creates a new OnlineStatus instance using the specified properties.
         * @function create
         * @memberof pb.OnlineStatus
         * @static
         * @param {pb.OnlineStatus.$Properties=} [properties] Properties to set
         * @returns {pb.OnlineStatus} OnlineStatus instance
         * @type {{
         *   (properties: pb.OnlineStatus.$Shape): pb.OnlineStatus & pb.OnlineStatus.$Shape;
         *   (properties?: pb.OnlineStatus.$Properties): pb.OnlineStatus;
         * }}
         */
        OnlineStatus.create = function(properties) {
            return new OnlineStatus(properties);
        };

        /**
         * Encodes the specified OnlineStatus message. Does not implicitly {@link pb.OnlineStatus.verify|verify} messages.
         * @function encode
         * @memberof pb.OnlineStatus
         * @static
         * @param {pb.OnlineStatus.$Properties} message OnlineStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnlineStatus.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.created_at != null && $Object.hasOwnProperty.call(message, "created_at"))
                $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== "")
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified OnlineStatus message, length delimited. Does not implicitly {@link pb.OnlineStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pb.OnlineStatus
         * @static
         * @param {pb.OnlineStatus.$Properties} message OnlineStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnlineStatus.encodeDelimited = function(message, writer) {
            return this.encode(message, (writer || $Writer.create()).fork()).ldelim();
        };

        /**
         * Decodes an OnlineStatus message from the specified reader or buffer.
         * @function decode
         * @memberof pb.OnlineStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pb.OnlineStatus & pb.OnlineStatus.$Shape} OnlineStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnlineStatus.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.pb.OnlineStatus();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.created_at);
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.type = value;
                        else
                            delete message.type;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes an OnlineStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pb.OnlineStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pb.OnlineStatus & pb.OnlineStatus.$Shape} OnlineStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnlineStatus.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OnlineStatus message.
         * @function verify
         * @memberof pb.OnlineStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OnlineStatus.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.created_at != null && $Object.hasOwnProperty.call(message, "created_at")) {
                let error = $root.google.protobuf.Timestamp.verify(message.created_at, _depth + 1);
                if (error)
                    return "created_at." + error;
            }
            if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            return null;
        };

        /**
         * Creates an OnlineStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pb.OnlineStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pb.OnlineStatus} OnlineStatus
         */
        OnlineStatus.fromObject = function (object, _depth) {
            if (object instanceof $root.pb.OnlineStatus)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".pb.OnlineStatus: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.pb.OnlineStatus();
            if (object.created_at != null) {
                if (!$util.isObject(object.created_at))
                    throw $TypeError(".pb.OnlineStatus.created_at: object expected");
                message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at, _depth + 1);
            }
            if (object.type != null)
                if (typeof object.type !== "string" || object.type.length)
                    message.type = $String(object.type);
            return message;
        };

        /**
         * Creates a plain object from an OnlineStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pb.OnlineStatus
         * @static
         * @param {pb.OnlineStatus} message OnlineStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OnlineStatus.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.created_at = null;
                object.type = "";
            }
            if (message.created_at != null && $Object.hasOwnProperty.call(message, "created_at"))
                object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options, _depth + 1);
            if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
                object.type = message.type;
            return object;
        };

        /**
         * Converts this OnlineStatus to JSON.
         * @function toJSON
         * @memberof pb.OnlineStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OnlineStatus.prototype.toJSON = function() {
            return OnlineStatus.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for OnlineStatus
         * @function getTypeUrl
         * @memberof pb.OnlineStatus
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        OnlineStatus.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/pb.OnlineStatus";
        };

        return OnlineStatus;
    })();

    return pb;
})();

export const google = $root.google = (() => {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    const google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        const protobuf = {};

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @typedef {Object} google.protobuf.Timestamp.$Properties
             * @property {number|Long|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @augments google.protobuf.Timestamp.$Properties
             * @deprecated Use google.protobuf.Timestamp.$Properties instead.
             */

            /**
             * Shape of a Timestamp.
             * @typedef {google.protobuf.Timestamp.$Properties} google.protobuf.Timestamp.$Shape
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @constructor
             * @param {google.protobuf.Timestamp.$Properties=} [properties] Properties to set
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */
            const Timestamp = function (properties) {
                if (properties)
                    for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            };

            /**
             * Timestamp seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp.$Properties=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             * @type {{
             *   (properties: google.protobuf.Timestamp.$Shape): google.protobuf.Timestamp & google.protobuf.Timestamp.$Shape;
             *   (properties?: google.protobuf.Timestamp.$Properties): google.protobuf.Timestamp;
             * }}
             */
            Timestamp.create = function(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp.$Properties} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function (message, writer, _depth) {
                if (!writer)
                    writer = $Writer.create();
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                if (message.seconds != null && $Object.hasOwnProperty.call(message, "seconds") && (typeof message.seconds === "object" ? message.seconds.low || message.seconds.high : message.seconds !== 0))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && $Object.hasOwnProperty.call(message, "nanos") && message.nanos !== 0)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                    for (let i = 0; i < message.$unknowns.length; ++i)
                        writer.raw(message.$unknowns[i]);
                return writer;
            };

            /**
             * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp.$Properties} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encodeDelimited = function(message, writer) {
                return this.encode(message, (writer || $Writer.create()).fork()).ldelim();
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Timestamp & google.protobuf.Timestamp.$Shape} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function (reader, length, _end, _depth, _target) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $Reader.recursionLimit)
                    throw $Error("max depth exceeded");
                let end, message, value;
                if (length === $undefined)
                    end = reader.len;
                else {
                    end = reader.pos + length;
                    if (end > reader.len)
                        throw $RangeError("index out of range");
                    length = reader.len;
                    reader.len = end;
                }
                message = _target || new $root.google.protobuf.Timestamp();
                while (reader.pos < end) {
                    let start = reader.pos;
                    let tag = reader.tag();
                    if (tag === _end) {
                        _end = $undefined;
                        break;
                    }
                    let wireType = tag & 7;
                    switch (tag >>>= 3) {
                    case 1: {
                            if (wireType !== 0)
                                break;
                            if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                                message.seconds = value;
                            else
                                delete message.seconds;
                            continue;
                        }
                    case 2: {
                            if (wireType !== 0)
                                break;
                            if (value = reader.int32())
                                message.nanos = value;
                            else
                                delete message.nanos;
                            continue;
                        }
                    }
                    reader.skipType(wireType, _depth, tag);
                    if (!reader.discardUnknown) {
                        $util.makeProp(message, "$unknowns", false);
                        (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                    }
                }
                if (length !== $undefined) {
                    if (reader.pos !== end)
                        throw $RangeError("index out of range");
                    reader.len = length;
                }
                if (_end !== $undefined)
                    throw $Error("missing end group");
                return message;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Timestamp & google.protobuf.Timestamp.$Shape} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decodeDelimited = function(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Timestamp message.
             * @function verify
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Timestamp.verify = function (message, _depth) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    return "max depth exceeded";
                if (message.seconds != null && $Object.hasOwnProperty.call(message, "seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && $Object.hasOwnProperty.call(message, "nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Timestamp} Timestamp
             */
            Timestamp.fromObject = function (object, _depth) {
                if (object instanceof $root.google.protobuf.Timestamp)
                    return object;
                if (!$util.isObject(object))
                    throw $TypeError(".google.protobuf.Timestamp: object expected");
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                let message = new $root.google.protobuf.Timestamp();
                if (object.seconds != null)
                    if (typeof object.seconds === "object" ? object.seconds.low || object.seconds.high : $Number(object.seconds) !== 0)
                        if ($util.Long)
                            message.seconds = $util.Long.fromValue(object.seconds, false);
                        else if (typeof object.seconds === "string")
                            message.seconds = $parseInt(object.seconds, 10);
                        else if (typeof object.seconds === "number")
                            message.seconds = object.seconds;
                        else if (typeof object.seconds === "object")
                            message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    if ($Number(object.nanos) !== 0)
                        message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp} message Timestamp
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Timestamp.toObject = function (message, options, _depth) {
                if (!options)
                    options = {};
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                    } else
                        object.seconds = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && $Object.hasOwnProperty.call(message, "seconds"))
                    if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                        object.seconds = typeof message.seconds === "number" ? $BigInt(message.seconds) : $util.Long.fromBits(message.seconds.low >>> 0, message.seconds.high >>> 0, false).toBigInt();
                    else if (typeof message.seconds === "number")
                        object.seconds = options.longs === $String ? $String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === $String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === $Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && $Object.hasOwnProperty.call(message, "nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Timestamp to JSON.
             * @function toJSON
             * @memberof google.protobuf.Timestamp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Timestamp.prototype.toJSON = function() {
                return Timestamp.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the type url for Timestamp
             * @function getTypeUrl
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
             * @returns {string} The type url
             */
            Timestamp.getTypeUrl = function(prefix) {
                if (prefix === $undefined)
                    prefix = "type.googleapis.com";
                return prefix + "/google.protobuf.Timestamp";
            };

            return Timestamp;
        })();

        return protobuf;
    })();

    return google;
})();

export {
  $root as default
};
